import {put, take, call, fork} from 'redux-saga/effects'
import {get, post} from '../fetch/fetch'
import { LOGIN,LOGOUT } from '@/fetch/url'
import {actionsTypes as IndexActionTypes} from '../reducers'
import {actionTypes as UserActionTypes} from '../reducers/userReducer'

export function* login(data) {
    yield put({type: IndexActionTypes.FETCH_START});
    try {
        return yield call(post, LOGIN, data)
    } catch (error) {
        yield put({type:IndexActionTypes.SET_MESSAGE,msgContent:'获取信息失败',msgType:0});
    } finally {
        yield put({type: IndexActionTypes.FETCH_END});
    }
}

export function* loginFlow () {
    while (true){
        let req = yield take(UserActionTypes.USER_LOGIN);
        let res = yield call(login, req.data);
        if(res){
            if(res && res.success){
                console.log('login data:',res)
                yield put({type: UserActionTypes.USER_LOGIN_RESPONSE,data:res});
            }else{
                yield put({type: IndexActionTypes.SET_MESSAGE, msgContent: res.message, msgType: 2});
            }
        }
    }
}

export function* logout(id) {
    yield put({type: IndexActionTypes.FETCH_START});
    try {
        return yield call(post, LOGOUT, {id})
    } catch (error) {
        yield put({type:IndexActionTypes.SET_MESSAGE,msgContent:'获取信息失败',msgType:0});
    } finally {
        yield put({type: IndexActionTypes.FETCH_END});
    }
}

export function* logoutFlow () {
    while (true){
        let req = yield take(UserActionTypes.USER_LOGOUT);
        let res = yield call(logout, req.id);
        if(res){
            if(res != null && res.success){
                yield put({type: UserActionTypes.USER_LOGOUT_RESPONSE,data:res});
            }else{
                yield put({type: IndexActionTypes.SET_MESSAGE, msgContent: res.message, msgType: 2});
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/sagas/userSaga.js